import { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

// The recipes a flavor goes into. Long lists show the first few names and a
// "+N more" toggle that expands the rest.
const PREVIEW = 4

export default function UsedInList({ names }: { names: string[] }) {
  const [open, setOpen] = useState(false)
  if (names.length === 0) {
    return <span className="text-xs italic text-muted-foreground/60">Not in a recipe yet</span>
  }
  const collapsible = names.length > PREVIEW + 1
  const shown = collapsible && !open ? names.slice(0, PREVIEW) : names
  return (
    <div className="text-sm leading-relaxed">
      <span>{shown.join(', ')}</span>
      {collapsible ? (
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          aria-expanded={open}
          className="ml-1.5 inline-flex items-center gap-0.5 whitespace-nowrap rounded px-1 text-xs font-medium text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {open ? (
            <>
              Show less <ChevronUp className="h-3 w-3" />
            </>
          ) : (
            <>
              +{names.length - PREVIEW} more <ChevronDown className="h-3 w-3" />
            </>
          )}
        </button>
      ) : null}
    </div>
  )
}
